module.exports = __webpack_public_path__ + "img/schnittkante_orange_ral2008.332173b6.jpg";